const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/DashboardPage.tsx';
import { PageLayout } from '../../layout/PageLayout';

import { AppBarMain as AppBarCommon } from './AppBar/AppBar';
import { Content } from './Content';
import { LoginData } from 'App/defs/loginDefs';
import { useECheckinRegisteredWorkItem } from 'App/store/workItem';
import { useSelector } from 'react-redux';
import { patRegisterWorkId } from 'App/store/login';

export const DashboardPage = () => {
    const appBar = <AppBarCommon />;
    // this is needed to trigger the loginType data
    useECheckinRegisteredWorkItem();
    const registerWorkId = useSelector(patRegisterWorkId);
    // this condition is needed to prevent api dashboard calling patapi before we have a token.
    const loginData = JSON.parse(sessionStorage.getItem(LoginData) as string);
    const loginType = loginData?.login_type;
    const canShowContent = loginType === 'IAM' || loginType === 'InvitationCode';
    return <PageLayout appBar={appBar}>{(registerWorkId || canShowContent) && <Content />}</PageLayout>;
};
